"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { IconGlyphicon } from 'generics/icons';
import { BootButton } from 'generics/buttons';
import { MarketGetAppTags } from 'api/ordersAPICall';

import { ViewAppIdIcon } from 'components/commonAssets';


// LogStream.enable( "VIEWMARKETEDITEMSLIST" );


export class ViewMarketAppFilterEditor extends React.Component  {
  constructor( props )  {
    super( props );
    this.state = {
      "tagmap" : [],
    };

  }


  composeTagmap( tags )  {
    const tagmap = {};
    const res = [];

    tags.map(  ({ name, loc, color }) =>  {
      if ( !loc )
        return;

      const [ ,category, tagname ] = (/^([^:]+)(:.*)?$/ig).exec( name );

      let catLoc = tagmap[category];
      if ( !catLoc )  {
        catLoc = tagmap[category] = { name: category, loc:"", tags:[] };
        res.push( catLoc );
      }

      if ( tagname )  {
        catLoc.tags.push({ name:name, loc:loc, color });
      }  else  {
        catLoc.loc = loc;
      }
    });

    return res.filter( x  =>  ( !!x.tags.length ) );
  }


  loadTags( appId )  {
    if ( !appId )  {
      this.setState( {"tagmap": []} );
      return;
    }

    MarketGetAppTags(
        appId

      ).then( ( tags ) =>  {
        LogStream("VIEWMARKETEDITEMSLIST").info( "MarketGetAppTags -> ", tags );
        this.setState( {"tagmap": this.composeTagmap( tags ) } );

      }).catch( ( reason ) =>  {
        this.setState( {"tagmap": []} );
        LogStream("VIEWMARKETEDITEMSLIST").error( "MarketGetAppTags - Failed (", reason, ")" );

      });
  }


  componentDidUpdate(prevProps, prevState)  {
    if (  prevProps.selectedApp != this.props.selectedApp  )  {
      this.loadTags( this.props.selectedApp );
    }
  }


  renderAppEntry( appId )  {
    const onSwitch = ()  => this.props.onUpdate(appId, null);

    return (
        <BootButton  key={appId}  active  onClick={onSwitch}  >
            <ViewAppIdIcon appId={appId} compact />
        </BootButton>
      );

  }


  renderAppList()  {
    return (
        <div className="appid-filter-menu">
          <div className="appid-filter-menu-label">
            {_I_("AppFilterEditor.label.byTitles")}
          </div>
          <div className="appid-filter-menu-list">
            {this.props.appIds.map(  (appId) => this.renderAppEntry(appId)  )}
          </div>
        </div>
      );
  }


  renderTagEntry({ loc, name, color })  {
    const checked = this.props.selectedTagsMap[name];
    const onToggleTag = () =>  {
        const newTags = Object.assign( {}, this.props.selectedTagsMap );
        if ( checked )
          delete newTags[name];
        else
          newTags[name] = { loc, name, color };

        this.props.onUpdate(this.props.selectedApp, newTags);
      };

    const style = color ? { color: `#${color}` } : undefined;

    return (
        <div  className="appid-filter-tag-entry"  key={name}
              onClick={onToggleTag}
            >
          <IconGlyphicon type={checked ? "check" : "unchecked"} />
          <span  style={style}  >{loc}</span>
        </div>
      );
  }


  renderTagCatedory(category)  {
    return (<div className="appid-filter-tag-category" key={category.name}>
        <div className="appid-filter-tag-category-name">{category.loc}</div>
        {category.tags.map(  (tag) =>  this.renderTagEntry(tag)  )}
      </div>);

  }

  tagRender(tagmap) {

    let historicalTagsMap = [];
    const historicalCategoriesNames = [
      'semihistorical',
      'fictional',
      'historical'
    ];

    tagmap.map(  (category, index) => {
      if(historicalCategoriesNames.indexOf(category.name) != -1)
      {
        historicalTagsMap = historicalTagsMap.concat(category.tags);
        tagmap.splice(index, 1);
      }
    });

    if(historicalTagsMap.length)
    {
      const tagsHistoryInfo = {
        'name': 'mixedHistorical',
        'loc': "",
        'tags': historicalTagsMap
      };

      tagmap.push(tagsHistoryInfo);
    }

    return tagmap;
  }

  renderAppOptions()  {
    const onClear = ()  => this.props.onUpdate(null, null);
    let tagmap = this.tagRender(this.state.tagmap);
    return (
        <div className="appid-filter-menu">
          <div className="appid-filter-menu-label">
            {_I_("AppFilterEditor.label.byTags")}
            <ViewAppIdIcon appId={this.props.selectedApp} compact />
          </div>
          <div className="appid-filter-menu-list">
            <BootButton  size="small"  onClick={onClear}  block >
              <IconGlyphicon type="remove" />&nbsp;
              {_I_("AppFilterEditor.label.clearFilter")}
            </BootButton>
            {tagmap.map(  (category) => this.renderTagCatedory(category)  )}
          </div>
        </div>
      );
  }


  render()  {
    if ( this.props.selectedApp )
      return this.renderAppOptions();

    return this.renderAppList();
  }
}


defineSimpleTerm( "AppFilterEditor.label.byTags",  "Filter by tags for",       {
  "ru_RU": "Фильтр по тегам",
  "cs_CZ": "Filter by tags for",
  "fr_FR": "Filtrer par tags pour",
  "de_DE": "Nach Tags filtern",
  "it_IT": "Filtra per tag",
  "ko_KR": "다음 태그를 포함하여 필터링",
  "pl_PL": "Filtruj tagi dla",
  "pt_PT": "Filter by tags for",
  "es_ES": "Filtrar por etiquetas para",
  "zh_CN": "按标签筛选",
  "zh_TW": "按標籤篩選"
} );


defineSimpleTerm( "AppFilterEditor.label.clearFilter",  "Clear filter",       {
  "ru_RU": "Отменить фильтр",
  "cs_CZ": "Clear filter",
  "fr_FR": "Supprimer le filtre",
  "de_DE": "Filter zurücksetzen",
  "it_IT": "Resetta filtri",
  "ko_KR": "필터 초기화",
  "pl_PL": "Wyczyść filtr",
  "pt_PT": "Clear filter",
  "es_ES": "Limpiar filtro",
  "zh_CN": "清除筛选",
  "zh_TW": "清除篩選"
} );


defineSimpleTerm( "AppFilterEditor.label.byTitles",  "Filter by titles",       {
  "ru_RU": "Фильтр по играм",
  "cs_CZ": "Filter by titles",
  "fr_FR": "Filtrer par titres",
  "de_DE": "Nach Titel filtern",
  "it_IT": "Filtra per titoli",
  "ko_KR": "다음 게임으로 필터링",
  "pl_PL": "Filtruj po tytułach",
  "pt_PT": "Filter by titles",
  "es_ES": "Filtrar por títulos",
  "zh_CN": "按标题筛选",
  "zh_TW": "按標題篩選"
} );

